import type { ComponentProps } from "react"
import { useCallback } from "react"
import { BracketCard as InternalBracketCard } from "../madness/BracketCard"

const DEFAULT_NFL_IMAGE = "https://a.bracky.app/assets/covers/nfl/super-bowl-2026.jpg"

type ExtendedSelectionCallback = (
  count: number,
  outcomes: string[],
  names: string[],
  images: string[],
  colors: string[],
  bracketTitle: string,
) => void

interface BracketCardProps
  extends Omit<ComponentProps<typeof InternalBracketCard>, "onSelectionChange" | "onDetailedSelectionChange"> {
  onSelectionChange?: ExtendedSelectionCallback
}

// Wrapper that extends BracketCard with selection tracking
function NFLBracket({ onSelectionChange, outcomes, title, ...props }: BracketCardProps) {
  const handleSelectionChange = useCallback(
    (count: number, slugs: string[], names: string[], images: string[], colors: string[], bracketTitle: string) => {
      onSelectionChange?.(count, slugs, names, images, colors, bracketTitle)
    },
    [onSelectionChange],
  )

  return (
    <InternalBracketCard
      imageUrl={DEFAULT_NFL_IMAGE}
      outcomes={outcomes}
      title={title}
      onDetailedSelectionChange={handleSelectionChange}
      {...props}
    />
  )
}

export const LandingDemoNFLBracket = NFLBracket
